import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';
import { FormBuilder } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AlertController, ModalController } from '@ionic/angular';
import { ContactSettingComponent } from '@modal/contact-setting/contact-setting.component';
import { MessagesPopupComponent } from '@modal/messages-popup/messages-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { RegUser } from '../../basic-reg/RegUser';
import { CommonUtil } from 'src/app/util/CommonUtil';

@Component({
  selector: 'app-pending-request-new',
  templateUrl: './pending-request-new.component.html',
  styleUrls: ['./pending-request-new.component.scss', '../../../../assets/css/style.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
  ]
})
export class PendingRequestNewComponent implements OnInit, OnDestroy {

  allRequestVar: boolean = true;
  allPendingVar: boolean = false;
  requestVar: boolean = false;
  loadingPendingData: boolean = false;
  loadingRequestedData: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  requestPath: string = '';
  user: RegUser = new RegUser();
  profileImageSrc: string = '';
  LoggedIn: boolean = false;

  requestedContacts: { contactUser: any; personalizedMsg?: string }[] = [];
  pendingRequests: { contactUser: any; personalizedMsg?: string }[] = [];
  contactIds: number[] = [];

  noDataFound: boolean = true;
  private navigationSubscription?: Subscription;
  private isInitialLoad: boolean = true;

  constructor(public global: Globals,
    public authService: AuthServiceService,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    public router: Router,
    private loader: LoaderService,
    public atrCtrl: AlertController,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit() {
    this.initializePendingPage();
    
    // Subscribe to navigation events to reload data when navigating to this page
    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url.includes('pending-request-new')) {
          // Skip the initial load to prevent duplicate API calls
          if (this.isInitialLoad) {
            this.isInitialLoad = false;
            return;
          }
          this.initializePendingPage();
        }
      });
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private initializePendingPage() {
    this.LoggedIn = this.authService.isLoggedIn();
    const loggedInUser = this.authService.getLoggedInUser();
    this.user = loggedInUser ?? new RegUser();
    this.profileImageSrc = this.authService.getProfilePicture() as string;
    if (!this.global.isEmpty(loggedInUser)) {
      this.user.imageUrl = this.profileImageSrc;
    }

    this.errorMessage = '';
    this.contactIds = [];
    this.noDataFound = true;

    this.getPendingRequestWithMe();
    this.getRequestedContacts();
  }

  getRequestedContacts = () => {
    this.errorMessage = '';
    this.requestedContacts = [];
    this.loadingRequestedData = true;
    this.cdr.detectChanges(); // Force update to show loader
    
    const request = this.authService.get('user/directory?' + this.requestPath + '=requestedList');
    if (!request) {
      this.loadingRequestedData = false;
      this.noDataFound = true;
      this.cdr.detectChanges();
      return;
    }

    request
      .subscribe((res: any) => {
        this.loadingRequestedData = false;
        if (res.success) {
          this.requestedContacts = this.global.decrypt(res.data);
          if (!this.global.isEmpty(this.requestedContacts)) {
            this.noDataFound = false;
            for (var i = 0; i < this.requestedContacts.length; i++) {
              this.contactIds.push(this.requestedContacts[i].contactUser.id);
            }
          }
        } else {
          this.errorMessage = res.message;
          this.noDataFound = true;
        }
        this.cdr.detectChanges(); // Force update with data
      }, (error: any) => {
        this.loadingRequestedData = false;
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  getPendingRequestWithMe = () => {
    this.errorMessage = '';
    this.pendingRequests = [];
    this.loadingPendingData = true;
    this.cdr.detectChanges(); // Force update to show loader
    
    const request = this.authService.get('user/directory?' + this.requestPath + '=pendingWithMeList');
    if (!request) {
      this.loadingPendingData = false;
      this.noDataFound = true;
      this.cdr.detectChanges();
      return;
    }

    request
      .subscribe((res: any) => {
        this.loadingPendingData = false;
        if (res.success) {
          this.pendingRequests = this.global.decrypt(res.data);
          if (this.pendingRequests != null && this.pendingRequests.length > 0) {
            this.noDataFound = false;
          }
        } else {
          this.errorMessage = res.message;
          this.noDataFound = true;
        }
        this.cdr.detectChanges(); // Force update with data
      }, (error: any) => {
        this.loadingPendingData = false;
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  openProfile(userContact: any, user: any, editEnabled: boolean, isSearchResult: boolean) {
    this.router.navigateByUrl('/profile-details', { state: { 'userContact': userContact, 'user': user, 'editEnabled': editEnabled, 'addEnabled': !this.contactIds.includes(user.id), 'isSearchResult': isSearchResult } });
    return false;
  }

  rejectContact(userContact: any) {
    this.errorMessage = '';
    userContact.status = "Rejected";
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=save', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Reinitialized the form state
          this.getPendingRequestWithMe();
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
  }

  cancelContact(userContact: any) {
    this.errorMessage = '';
    userContact.status = "Canceled";
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=save', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Reinitialized the form state
          this.getRequestedContacts();
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
  }

  approveContact(userContact: any) {
    this.errorMessage = '';
    userContact.status = "Confirmed";
    // console.log(userContact);
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=save', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          this.dismiss('OK');
          this.gotoDashboard();
        } else {
          this.errorMessage = res.message;
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
      });
    return false;
  }

  async dismiss(data: any) {
    this.modalController.dismiss(data);
  }

  async openSettingModal(contactUser: any, user: any) {
    const modal = await this.modalController.create({
      component: ContactSettingComponent,
      componentProps: {
        user: user,
        personalizedMsg: '',
        isSender: false
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        var updatedData = dataReturned.data;
        if (!this.global.isEmpty(updatedData)) {
          contactUser.recieverStartTime = updatedData.recieverStartTime;
          contactUser.recieverEndTime = updatedData.recieverEndTime;
          contactUser.recieverPrefTime = updatedData.recieverPrefTime;
          contactUser.recieverCommChanel = updatedData.recieverCommChanel;
          contactUser.recieverCategory = updatedData.recieverCategory;
          this.approveContact(contactUser);
        }
      }
    });

    modal.present();
  }

  async messagespopup(msg: string) {
    // console.log(msg);
    const modal = await this.modalController.create({
      component: MessagesPopupComponent,
      componentProps: {
        personalizedMsg: msg
      }
    });

    return await modal.present();
  }

  allRequest() {
    this.allPendingVar = false;
    this.allRequestVar = true;
    this.requestVar = false;
    if (this.pendingRequests == null || this.pendingRequests.length == 0 || this.requestedContacts == null || this.requestedContacts.length == 0) {
      this.noDataFound = true;
    } else {
      this.noDataFound = false;
    }
  }
  pendingRequest() {
    this.allPendingVar = true;
    this.allRequestVar = false;
    this.requestVar = false;
    if (this.pendingRequests == null || this.pendingRequests.length == 0) {
      this.noDataFound = true;
    } else {
      this.noDataFound = false;
    }
  }

  requested() {
    this.allPendingVar = false;
    this.allRequestVar = false;
    this.requestVar = true;
    if (this.requestedContacts == null || this.requestedContacts.length == 0) {
      this.noDataFound = true;
    } else {
      this.noDataFound = false;
    }
  }

  gotoDashboard() {
    this.router.navigateByUrl("directory-dashbord-new", { state: { 'refresh': true}});
  }

  getMaskedEmail(email: string): string {
    return CommonUtil.getMaskedEmail(email);
  }

  getMaskedPhone(phone: string): string {
    return CommonUtil.getMaskedPhone(phone);
  }

}
